import { Space, Typography } from 'antd';
import Icon from 'components/icons';
import { reportStatus } from 'contexts/reporting/utils';

const { Text } = Typography;

type StatusVariant = 'desktop' | 'mobile';

interface StatusCellProps {
  status: string;
  variant?: StatusVariant;
}

const statusColorMap: Record<'completed' | 'pending' | 'error', string> = {
  completed: 'var(--positive-dark)',
  pending: 'var(--performance-avg-negative-dark)',
  error: 'var(--performance-negative-dark)',
};

const StatusCell = ({ status, variant = 'desktop' }: StatusCellProps): JSX.Element => {
  let statusIcon: 'StatusError' | 'StatusCompleted' | 'StatusPending';
  let statusText: 'Completed' | 'Pending' | 'Error';
  let statusKey: 'completed' | 'pending' | 'error';

  switch (status) {
    case reportStatus.completed:
      statusIcon = 'StatusCompleted';
      statusText = 'Completed';
      statusKey = 'completed';
      break;
    case reportStatus.pending:
    case reportStatus.partialFinished:
      statusIcon = 'StatusPending';
      statusText = 'Pending';
      statusKey = 'pending';
      break;
    default:
      statusIcon = 'StatusError';
      statusText = 'Error';
      statusKey = 'error';
  }

  const showIcon = variant !== 'mobile';
  const textStyle = variant === 'mobile' ? { color: statusColorMap[statusKey] } : undefined;
  const mobileAttributes =
    variant === 'mobile' ? { 'data-status-color': statusColorMap[statusKey] } : {};

  return (
    <Space size={showIcon ? 8 : 0}>
      {showIcon && <Icon icon={statusIcon} size="small" aria-label={statusText} role="img" />}
      <Text style={textStyle} {...mobileAttributes}>
        {statusText}
      </Text>
    </Space>
  );
};

export default StatusCell;
